import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import csTableMapping from '@/locales/cs/table-mapping.json'
import cs from '@/locales/cs/translation.json'
import csWhatsNew from '@/locales/cs/whats-new.json'
import enTableMapping from '@/locales/en/table-mapping.json'
import en from '@/locales/en/translation.json'
import enWhatsNew from '@/locales/en/whats-new.json'
import frTableMapping from '@/locales/fr/table-mapping.json'
import fr from '@/locales/fr/translation.json'
import frWhatsNew from '@/locales/fr/whats-new.json'
import skTableMapping from '@/locales/sk/table-mapping.json'
import sk from '@/locales/sk/translation.json'
import skWhatsNew from '@/locales/sk/whats-new.json'
import thTableMapping from '@/locales/th/table-mapping.json'
import th from '@/locales/th/translation.json'
import thWhatsNew from '@/locales/th/whats-new.json'
import { APP_LANGUAGE_CODES, type AppLanguage, FALLBACK_LANGUAGE } from './languages'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: FALLBACK_LANGUAGE,
    supportedLngs: [...APP_LANGUAGE_CODES],
    // `satisfies` makes a language added to APP_LANGUAGES without a bundle
    // here a compile error, rather than a toggle that silently shows English.
    resources: {
      en: { translation: { ...en, whatsNew: enWhatsNew, tableMapping: enTableMapping } },
      cs: { translation: { ...cs, whatsNew: csWhatsNew, tableMapping: csTableMapping } },
      fr: { translation: { ...fr, whatsNew: frWhatsNew, tableMapping: frTableMapping } },
      sk: { translation: { ...sk, whatsNew: skWhatsNew, tableMapping: skTableMapping } },
      th: { translation: { ...th, whatsNew: thWhatsNew, tableMapping: thTableMapping } },
    } satisfies Record<AppLanguage, { translation: unknown }>,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'spectre-language',
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
